//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.CutAngle.js";
import "../CAM/CAM.CutPatternBuilder.js";
import "../CAM/CAM.StepoverBuilder.js";
let d=[[[0,"ApplyAtBoundary",1,0],[0,"ApplyAtPartSurface",1,0],[0,"ApplyFilletAt",1,0],[0,"BndAddPasses",1,0],[0,"BndCustomStart",1,0],[0,"BndPocketDir",1,0],[0,"BndProfilePass",1,0],[0,"BndProfilePassStock",1,0],[1,"CutAngle",0,"CAM.CutAngle",0],[1,"CutPatternBuilder",0,"CAM.CutPatternBuilder",0],[0,"CutPatternCenter",1,0],[0,"DisToolEndProj",1,0],[0,"DispContact",1,0],[0,"DispContactNormal",1,0],[0,"DispToolEnd",1,0],[0,"DmBndStock",1,0],[0,"IslandCleanup",1,0],[0,"IslandCleanupStatus",1,0],[0,"PatternCenterPoint",1,"Point",0],[0,"RegionConnection",1,0],[1,"StepoverBuilder",0,"CAM.StepoverBuilder",0],[0,"UsePart",1,0]],[[["count"],"GetDmBndIntolOuttol",{R_:{values:""}},0,0],[["values"],"SetDmBndIntolOuttol",{},1,0],[[],"GetBndCutPattern",{R_:{bndCutPattern:''}},0,0],[["bndCutPattern"],"SetBndCutPattern",{},1,0],[[],"GetBndCutTraversal",{R_:{bndCutTraversal:''}},0,0],[["bndCutTraversal"],"SetBndCutTraversal",{},1,0],[["count"],"GetDmBndCutZigDir",{R_:{bndCutZigDir:""}},0,0],[["bndCutZigDir"],"SetDmBndCutZigDir",{},1,0]],[]];
SPLM.CAM.DmBndBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.DmBndBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.DmBndBuilder.BndCutPatternTypes = Object.freeze({
    "FollowPeriphery" : "FollowPeriphery", "Profile" : "Profile", "Sep1" : "Sep1", "ParallelLines" : "ParallelLines", "RadialLines" : "RadialLines", "ConcArcs" : "ConcArcs", "Sep2" : "Sep2", "StandardDrive" : "StandardDrive"});

SPLM.CAM.DmBndBuilder.BndCutTraversalTypes = Object.freeze({
    "ZigZag" : "ZigZag", "Zig" : "Zig", "ZigContour" : "ZigContour", "Stepover" : "Stepover"});

SPLM.CAM.DmBndBuilder.BndPatternCenterTypes = Object.freeze({
    "MethodAutomatic" : "MethodAutomatic", "MethodSpecify" : "MethodSpecify"});

SPLM.CAM.DmBndBuilder.BndPocketDirTypes = Object.freeze({
    "Outward" : "Outward", "Inward" : "Inward"});

SPLM.CAM.DmBndBuilder.BndCustomStartTypes = Object.freeze({
    "Custom" : "Custom", "Automatic" : "Automatic"});

SPLM.CAM.DmBndBuilder.UsePartTypes = Object.freeze({
    "PartContainOff" : "PartContainOff", "PartContainLargestLoop" : "PartContainLargestLoop", "PartContainAllLoops" : "PartContainAllLoops"});

SPLM.CAM.DmBndBuilder.ApplyFilletAtTypes = Object.freeze({
    "Boundary" : "Boundary", "Surface" : "Surface", "BoundaryAndSurface" : "BoundaryAndSurface"});

export default SPLM;